import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBottomSheetModule, MatButtonModule, MatCheckboxModule, MatFormFieldModule, MatIconModule } from '@angular/material';
import { MatListModule } from '@angular/material/list';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { BottomSheetComponent } from './components/bottom-sheet/bottom-sheet.component';
import { ExhibitorModule } from './features/exhibitor/exhibitor.module';
import { NavigationModule } from './features/navigation/navigation.module';
import { AppRoutingModule } from './routing/app-routing.module';


@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,

        MatButtonModule,
        MatCheckboxModule,
        MatListModule,
        MatIconModule,
        MatFormFieldModule,
        MatBottomSheetModule,

        ExhibitorModule,
        NavigationModule,
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production})

    ],
    declarations: [
        AppComponent,
        BottomSheetComponent,
    ],
    providers: [],
    bootstrap: [AppComponent],
    entryComponents: [
        BottomSheetComponent
    ]
})
export class AppModule {
}
